import script from "./BaseLogo.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseLogo.vue?vue&type=script&setup=true&lang=js"

import "./BaseLogo.vue?vue&type=style&index=0&id=1b9ab674&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1b9ab674"]])

export default __exports__